module.exports = __webpack_public_path__ + "img/swiper-2.61444083.jpg";